import React from "react";
import PaintingCompetition from "./PaintingCompetition";
import InnerBannerBreadcrumb from "../../../components/shared/breadcrumb/InnerBannerBreadcrumb";
import OtherCelebrations from "./OtherCelebrations";
import { useDispatch, useSelector } from "react-redux";
import { setCompetitionsTabStr } from "../../../redux/slice/sliceHome";
import { useLanguageTranslation } from "../../../hooks/useLanguageTranslation";
import AzadiKaAmritMahotsav from "./AzadiKaAmritMahotsav";
import { useLocation } from "react-router-dom";
import useSeo from "../../../hooks/useSeo";

const CompetitionsAndCelebrations = () => {
  const { amritTabStr } = useSelector((state) => state.homeSlice);
  const { getText } = useLanguageTranslation();
  const dispatch = useDispatch();

  // for SEO
  const { pathname } = useLocation();
  const { innerBannerTitle, innerBannerImage } = useSeo({ pathname });

  return (
    <>
      <InnerBannerBreadcrumb
        bannerImage={innerBannerImage}
        title={innerBannerTitle}
        isActive={innerBannerTitle}
        titleLink="/competition-celebrations"
        levelTwo={false}
        levelThree={false}
      />
      <div className="inner-container">
        <div className="container">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12 wow zoomIn">
                <section className="leftmenu-hori">
                  <ul>
                    <li
                      className={
                        amritTabStr === "painting-competition" ? "active" : ""
                      }
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(
                            setCompetitionsTabStr("painting-competition")
                          );
                        }}
                      >
                        <div className="icon icon-painting"></div>
                        {getText("BEE Painting", "BEE चित्रकला")}
                      </a>
                    </li>
                    <li
                      className={
                        amritTabStr === "other-ceremonies" ? "active" : ""
                      }
                    >
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCompetitionsTabStr("other-ceremonies"));
                        }}
                      >
                        <div className="icon icon-ceremonies"></div>
                        {getText("Other Celebrations", "अन्य समारोह")}
                      </a>
                    </li>
                    <li className={amritTabStr === "amrit" ? "active" : ""}>
                      <a
                        href="#"
                        onClick={(e) => {
                          e.preventDefault();
                          dispatch(setCompetitionsTabStr("amrit"));
                        }}
                      >
                        <div className="icon icon-mahotsav"></div>
                        {getText(
                          "Azadi Ka Amrit Mahotsav",
                          "आज़ादी का अमृत महोत्सव"
                        )}
                      </a>
                    </li>
                  </ul>
                </section>
              </div>
            </div>
            {/* <div className="mb-2">
                <PageLastUpdated lastUpdatedOn={lastUpdatedOn} />
              </div> */}
            {amritTabStr === "painting-competition" && <PaintingCompetition />}
            {amritTabStr === "other-ceremonies" && <OtherCelebrations />}
            {amritTabStr === "amrit" && <AzadiKaAmritMahotsav />}
          </div>
        </div>
      </div>
    </>
  );
};

export default CompetitionsAndCelebrations;
